"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Box = _interopRequireDefault(require("../Box"));
var _theme = _interopRequireDefault(require("../../theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Card = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Card",
  componentId: "sc-25oapg-0"
})(["box-shadow:0px 2px 8px 0px #08051c14;background-color:white;border-radius:", ";"], _theme["default"].borderRadiusLarge);
var _default = exports["default"] = Card;